// extracted by mini-css-extract-plugin
export var button = "_g2-4";
export var hasDarkBackground = "_g2-7";
export var hasLightBackground = "_g2-6";
export var iconWrapper = "_g2-0";
export var large = "_g2-2";
export var medium = "_g2-1";
export var small = "_g2-5";
export var xsmall = "_g2-3";